// extracted by mini-css-extract-plugin
export default {"container":"App_container__UpGMx","contents":"App_contents__t0ja-"};